var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-GPS_Clock"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GPS_Clock",
    "data-name": "GPS Clock",
    clipPath: "url(#clip-GPS_Clock)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "GPS_Clock-2",
    "data-name": "GPS Clock",
    transform: "translate(0 22.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M488,387.372H24a24.071,24.071,0,0,1-24-24v-229.7a24.071,24.071,0,0,1,24-24H488a24.071,24.071,0,0,1,24,24v229.7A24.071,24.071,0,0,1,488,387.372Z",
    fill: "#e21b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M362.3,298.572H125.7a8,8,0,0,1-8-8l24-116.3a8,8,0,0,1,8-8H386.288a8,8,0,0,1,8,8l-24,116.3A8,8,0,0,1,362.3,298.572Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M295.056,166.276H152.32a10.642,10.642,0,0,0-10.608,10.608l-24,111.072a10.642,10.642,0,0,0,10.608,10.608h62.488Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M359.68,301.22H128.32a13.281,13.281,0,0,1-13.264-13.264l24-111.064a13.281,13.281,0,0,1,13.264-13.264H383.68a13.281,13.281,0,0,1,13.264,13.264l-24,111.064A13.281,13.281,0,0,1,359.68,301.22ZM152.32,168.932a8,8,0,0,0-8,8L120.32,288a8,8,0,0,0,8,7.96H359.68a8.007,8.007,0,0,0,7.96-7.96l24-111.064a8,8,0,0,0-7.96-8Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M198.472,189.676h8.984V235.4H202.92V194.148h-7.2Z",
    fill: "#e21b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M229.344,204H224.96a15.78,15.78,0,0,1,4.52-11.112,14.587,14.587,0,0,1,10.712-4.344,13.61,13.61,0,0,1,14.1,13.08c.008.2.008.408.008.608a14.97,14.97,0,0,1-1.864,7.288,52.2,52.2,0,0,1-7.2,9.224L233.848,231.02h21.1v4.416h-31.08l17.472-18.88a56,56,0,0,0,6.912-8.448,11.463,11.463,0,0,0,1.6-5.8,8.939,8.939,0,0,0-2.872-6.64,9.767,9.767,0,0,0-7.048-2.784,9.9,9.9,0,0,0-7.3,2.92A12.621,12.621,0,0,0,229.344,204Z",
    fill: "#e21b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M266.9,200.716a3.866,3.866,0,1,1-2.7,1.144A3.639,3.639,0,0,1,266.9,200.716Zm0,27.856a3.858,3.858,0,0,1,2.7,6.568,3.781,3.781,0,0,1-5.352.056l-.056-.056a3.868,3.868,0,0,1,0-5.448A3.66,3.66,0,0,1,266.9,228.572Z",
    fill: "#e21b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M276.912,212.556a39.533,39.533,0,0,1,1.936-13.992,16.267,16.267,0,0,1,5.5-7.5,13.262,13.262,0,0,1,7.928-2.552,13.508,13.508,0,0,1,8.048,2.568,16.818,16.818,0,0,1,5.7,7.688,37.032,37.032,0,0,1,2.1,13.776,37.519,37.519,0,0,1-2.064,13.712,17.006,17.006,0,0,1-5.712,7.688,13.616,13.616,0,0,1-8.08,2.6,13.262,13.262,0,0,1-7.9-2.52,16.2,16.2,0,0,1-5.48-7.5A38.872,38.872,0,0,1,276.912,212.556Zm4.32.08a37.2,37.2,0,0,0,1.392,11.72,12.432,12.432,0,0,0,4.08,6.024,9.025,9.025,0,0,0,11.408.04,12.212,12.212,0,0,0,4-6.024,35.783,35.783,0,0,0,1.712-11.76,35.138,35.138,0,0,0-1.52-11.3,13.263,13.263,0,0,0-4.208-6.4,8.983,8.983,0,0,0-11.4,0,12.534,12.534,0,0,0-4.072,6A37.3,37.3,0,0,0,281.232,212.636Z",
    fill: "#e21b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M312.192,212.556a39.533,39.533,0,0,1,1.936-13.992,16.267,16.267,0,0,1,5.5-7.5,13.262,13.262,0,0,1,7.928-2.552,13.508,13.508,0,0,1,8.048,2.568,16.818,16.818,0,0,1,5.7,7.688,37.032,37.032,0,0,1,2.1,13.776,37.519,37.519,0,0,1-2.064,13.712,17.006,17.006,0,0,1-5.712,7.688,13.616,13.616,0,0,1-8.08,2.6,13.262,13.262,0,0,1-7.9-2.52,16.2,16.2,0,0,1-5.48-7.5A39.049,39.049,0,0,1,312.192,212.556Zm4.32.08a37.2,37.2,0,0,0,1.392,11.72,12.432,12.432,0,0,0,4.08,6.024,9.025,9.025,0,0,0,11.408.04,12.212,12.212,0,0,0,4-6.024,35.783,35.783,0,0,0,1.712-11.76,35.138,35.138,0,0,0-1.52-11.3,13.263,13.263,0,0,0-4.208-6.4,8.983,8.983,0,0,0-11.4,0,12.534,12.534,0,0,0-4.072,6A37.3,37.3,0,0,0,316.512,212.636Z",
    fill: "#e21b1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M199.792,255.2h2.072l4.144,14.6,5.816-14.6h.416l5.752,14.6,4.208-14.6h2.064L218.4,275.492h-.376l-6.008-15.336-6.136,15.336H205.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M228,255.2h11.616v1.976h-9.6v6.352h9.5v1.992h-9.464v8h9.5V275.5H228Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M243.144,275.492V255.2h4.208a21.375,21.375,0,0,1,6.6.728,8.823,8.823,0,0,1,4.6,3.584,11.726,11.726,0,0,1,.352,11.44,8.46,8.46,0,0,1-3.416,3.416,12.869,12.869,0,0,1-5.9,1.1h-6.448Zm1.952-1.92h2.344a21.952,21.952,0,0,0,5.824-.52,6.7,6.7,0,0,0,3.592-2.68,8.254,8.254,0,0,0,1.32-4.728,8.773,8.773,0,0,0-1.416-5.016,7.18,7.18,0,0,0-4-2.848,23.976,23.976,0,0,0-6.272-.584h-1.432Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M278.608,255.2h2.024v13.68a13.133,13.133,0,0,1-.488,4.392,4.11,4.11,0,0,1-1.6,1.968,4.991,4.991,0,0,1-2.776.736,6.329,6.329,0,0,1-2.4-.48,9.9,9.9,0,0,1-2.64-1.672l1.08-1.6a16.115,16.115,0,0,0,2.64,1.6,3.4,3.4,0,0,0,1.344.3,2.565,2.565,0,0,0,1.6-.528,2.727,2.727,0,0,0,.992-1.392,13.166,13.166,0,0,0,.28-3.36Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M293.848,255.2l9.448,20.272h-2.184l-3.2-6.672H289.2l-3.2,6.672h-2.256l9.6-20.272Zm-.248,4.3-3.48,7.344h6.936Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M306.456,275.492V255.2h.448l13.5,15.536V255.2h2v20.272h-.456l-13.392-15.344v15.344Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M337.9,255.2h4v20.272h-2.008V257.2h-3.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M186.088,235.4H160.872a.615.615,0,0,1-.6-.6V215.6a.615.615,0,0,1,.6-.6h25.216a.615.615,0,0,1,.6.6v19.2A.615.615,0,0,1,186.088,235.4Z",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M164.712,220.644h1.8a9.55,9.55,0,0,1,2.08.144,2.338,2.338,0,0,1,1.272.8,2.289,2.289,0,0,1,.488,1.5,2.2,2.2,0,0,1-.48,1.48,2.391,2.391,0,0,1-1.328.8,12.175,12.175,0,0,1-2.288.144H165.6v4.2h-.912v-9.064Zm.912.888v3.056h1.52a3.924,3.924,0,0,0,1.36-.168,1.338,1.338,0,0,0,.672-.552,1.544,1.544,0,0,0,0-1.672,1.4,1.4,0,0,0-.64-.536,4.089,4.089,0,0,0-1.32-.152Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M171.744,229.676l1.3-9.04h.144l3.68,7.416,3.624-7.416h.144l1.3,9.04h-.888l-.888-6.472-3.2,6.456h-.224l-3.2-6.5-.888,6.5Z",
    fill: "#303030"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 433.76,
    height: 14.968,
    transform: "translate(39.128 387.364)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y2: 132,
    transform: "translate(88.5 -21.832)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y2: 132,
    transform: "translate(436.5 -21.832)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("text", {
    id: "GPS_SIGNAL",
    "data-name": "GPS SIGNAL",
    transform: "translate(30 357.668)",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "GPS SIGNAL")), /*#__PURE__*/React.createElement("text", {
    id: "INDIAN_RAILWAYS",
    "data-name": "INDIAN RAILWAYS",
    transform: "translate(184 125.668)",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "INDIAN RAILWAYS")), /*#__PURE__*/React.createElement("text", {
    id: "GPS_TIME",
    "data-name": "GPS TIME",
    transform: "translate(30 125.668)",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "GPS TIME")), /*#__PURE__*/React.createElement("text", {
    id: "PLATFORM_CLOCK",
    "data-name": "PLATFORM CLOCK",
    transform: "translate(362 125.668)",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "PLATFORM CLOCK")), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(-4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(375 343.668)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5,
    cy: 16.5,
    rx: 64.5,
    ry: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5,
    cy: 16.5,
    rx: 63.5,
    ry: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "bentron",
    transform: "translate(404 345.668)",
    fontSize: 18,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "bentron")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsClock);
export default __webpack_public_path__ + "static/media/GPS Clock.4684f26bb1ad0bffd982472f9f697e74.svg";
export { ForwardRef as ReactComponent };